import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import AuthShell from "@/components/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell testid="forgot-page" title="Reset your password"
               subtitle="Enter your email and we'll send a secure link to reset your password.">
      {sent ? (
        <div className="space-y-4" data-testid="forgot-sent">
          <div className="text-sm text-kid-navy bg-kid-skytint border border-kid-line rounded-xl px-4 py-4">
            If an account exists for that email, a reset link has been sent. Please check your inbox.
          </div>
          <Link to="/login" className="kid-btn kid-btn-ghost h-12 w-full">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          {error && <div className="text-sm text-kid-coral bg-red-50 border border-red-100 rounded-xl px-4 py-3">{error}</div>}
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                   data-testid="forgot-email-input" placeholder="you@example.com" className="h-12 rounded-xl" />
          </div>
          <button type="submit" disabled={busy} className="kid-btn kid-btn-primary w-full h-12 disabled:opacity-60" data-testid="forgot-submit-button">
            {busy ? "Sending…" : "Send reset link"}
          </button>
          <p className="text-center text-sm text-kid-muted">
            <Link to="/login" className="text-kid-teal font-semibold">Back to sign in</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
